import 'bootstrap/js/modal';
import $ from 'jquery';
import appleService from '~/app/javascript/src/services/apple_service';
import facebookService from '~/app/javascript/src/services/facebook_service';
import googleService from '~/app/javascript/src/services/google_service';
import loginService, * as loginServiceErrors from '~/app/javascript/src/services/login_service';
import validator from '~/app/javascript/src/utils/validator';

const defaultMainSelector = '.js-login-modal';

class LoginModal {
  constructor(mainSelector = defaultMainSelector) {
    this.successLogin = this.successLogin.bind(this);
    this.facebookSuccessLogin = this.facebookSuccessLogin.bind(this);
    this.successEvaluation = this.successEvaluation.bind(this);

    this.$loginModal = $(mainSelector);
    this.$registerPage = $('.js-login-register', this.$loginModal);
    this.$enterPage = $('.js-login-enter', this.$loginModal);
    this.$recoveryPage = $('.js-login-recovery', this.$loginModal);
    this.$alertMessages = $('.js-login-alert-message', this.$loginModal);
    this.$disableables = $('.js-disableable', this.$loginModal);
    this.$inputEmail = $('.js-input-email', this.$loginModal);
    this.$inputPassword = $('.js-input-password', this.$loginModal);
    this.$genericError = $('.js-generic-error', this.$loginModal);
    this.$invalidEmail = $('.js-invalid-email', this.$loginModal);
    this.$inputs = $('input', this.$loginModal);
    this.$goRegister = $('.js-login-go-register', this.$loginModal);
    this.$goEnter = $('.js-login-go-enter', this.$loginModal);
    this.$goRecovery = $('.js-login-go-recovery', this.$loginModal);
    this.$loginByFacebook = $('.js-login-by-facebook', this.$loginModal);
    this.$loginByGoogle = $('.js-login-by-google', this.$loginModal);
    this.$loginByApple = $('.js-login-by-apple', this.$loginModal);
    this.$registerForm = $('.js-register-form', this.$loginModal);
    this.$enterForm = $('.js-enter-form', this.$loginModal);
    this.$recoveryForm = $('.js-recovery-form', this.$loginModal);
    this.$registerBtn = $('.js-register-btn', this.$loginModal);
    this.$loginStepper = $('.js-login-stepper', this.$loginModal);
    this.$useFacebook = $('.js-use-facebook', this.$loginModal);
    this.$useGoogle = $('.js-use-google', this.$loginModal);
    this.$recoverPassword = $('.js-recover-password', this.$loginModal);
    this.$recoveryBtn = $('.js-login-recovery-btn', this.$loginModal);
    this.$accountSuspended = $('.js-account-suspended', this.$loginModal);
    this.$passwordTooShort = $('.js-password-too-short', this.$loginModal);
    this.$invalidLogin = $('.js-invalid-login', this.$loginModal);
    this.$recoverySuccess = $('.js-recovery-success', this.$loginModal);
    this.$emailNotFound = $('.js-email-not-found', this.$loginModal);
    this.$enterBtn = $('.js-enter-btn', this.$loginModal);
    this.$closeBtn = $('.js-close-btn', this.$loginModal);

    this.userEmail = '';

    this.$inputEmail.on('keyup', (e) => {
      this.userEmail = e.target.value;
      // Don't remove invalid email message if pressed key is ENTER
      if (e.which !== 13) {
        this.$invalidEmail.addClass('hidden');
      }
    });

    this.$inputs.on('change', () => this.$alertMessages.addClass('hidden'));
    this.$goRegister.on('click', this.renderRegisterPage.bind(this));
    this.$goEnter.on('click', this.renderEnterPage.bind(this));
    this.$goRecovery.on('click', this.renderRecoveryPage.bind(this));
    this.$loginByFacebook.on('click', this.loginFacebook.bind(this));
    this.$loginByGoogle.on('click', this.loginGoogle.bind(this));
    this.$loginByApple.on('click', this.loginApple.bind(this));

    this.setFormSubmit(this.$registerForm, this.register.bind(this), { validatePassword: true });
    this.setFormSubmit(this.$enterForm, this.enter.bind(this));
    this.setFormSubmit(this.$recoveryForm, this.recover.bind(this));

    this.$loginModal.on('hidden.bs.modal', this.closeHandler.bind(this));
  }

  setFormSubmit($form, callback, { validatePassword } = {}) {
    return $form.on('submit', (e) => {
      e.preventDefault();
      this.userEmail = this.userEmail || this.$inputEmail.toArray().reduce((acc, el) => acc || el.value, '');
      const isEmailValid = validator.validate('email', this.userEmail);
      let isPasswordValid = true;

      if (validatePassword) {
        isPasswordValid = this.$inputPassword.filter(':visible').val().length >= 7;
      }

      if (!isEmailValid) {
        this.$invalidEmail.removeClass('hidden');
      }

      if (!isPasswordValid) {
        this.$passwordTooShort.removeClass('hidden');
      }

      if (isEmailValid && isPasswordValid) {
        this.$alertMessages.addClass('hidden');
        const data = $form.serialize();
        callback(data);
      }
    });
  }

  show(options = {
    block: false,
    closeOnSucess: false,
    recoveryEmail: null,
    hideCloseBtn: false,
    backdrop: 'static',
    onSuccess: null,
    onClose: null,
    shouldShowStepper: false,
  }) {
    this.enableAll();
    this.options = options;
    const {
      block,
      recoveryEmail,
      hideCloseBtn,
      backdrop,
      shouldShowStepper,
    } = options;
    const bootstrapModalOptions = block ? ({ show: true, backdrop, keyboard: false }) : 'show';
    this.$loginModal.modal(bootstrapModalOptions);

    if (hideCloseBtn) {
      this.$closeBtn.addClass('hidden');
    } else {
      this.$closeBtn.removeClass('hidden');
    }

    if (recoveryEmail) {
      this.userEmail = recoveryEmail;
      this.renderRecoveryPage();
    } else {
      this.renderRegisterPage();
    }

    if (shouldShowStepper) {
      this.showStepper();
    }

    return Promise.all([
      facebookService.loadSdk().then(() => {
        this.$loginByFacebook
          .removeClass('login-modal__facebook-btn--unload')
          .removeClass('login-modal__link--unload');
      }),
      googleService.loadSdk().then(() => {
        this.$loginByGoogle
          .removeClass('login-modal__google-btn--unload')
          .removeClass('login-modal__link--unload');
      }),
      appleService.loadSdk().then(() => {
        this.$loginByApple
          .removeClass('login-modal__apple-btn--unload')
          .removeClass('login-modal__link--unload');
      }),
    ]);
  }

  reset() {
    this.$registerPage.addClass('hidden');
    this.$enterPage.addClass('hidden');
    this.$recoveryPage.addClass('hidden');
    this.$alertMessages.addClass('hidden');
    this.$inputEmail.val(this.userEmail).trigger('keyup');
    this.$inputPassword.val('');
  }

  renderRegisterPage() {
    this.reset();
    this.$registerPage.removeClass('hidden');
  }

  renderEnterPage() {
    this.reset();
    this.$enterPage.removeClass('hidden');
  }

  renderRecoveryPage() {
    this.reset();
    this.$recoveryPage.removeClass('hidden');
  }

  showStepper() {
    this.$loginStepper.removeClass('hidden');
  }

  disableAll() {
    this.$disableables.prop('disabled', true).attr('disabled', true);
  }

  enableAll() {
    this.$disableables.prop('disabled', false).attr('disabled', false);
  }

  register(loginData) {
    this.$registerBtn.addClass('btn-loading');
    this.disableAll();

    loginService.register(loginData).then(this.successLogin).catch((error) => {
      this.$registerBtn.removeClass('btn-loading');
      this.enableAll();

      switch (error.code) {
        case loginServiceErrors.ERROR_ALREADY_FACEBOOK_USER:
          this.$useFacebook.removeClass('hidden');
          break;
        case loginServiceErrors.ERROR_ALREADY_GOOGLE_USER:
          this.$useGoogle.removeClass('hidden');
          break;
        case loginServiceErrors.ERROR_INVALID_LOGIN:
          this.$recoverPassword.removeClass('hidden');
          break;
        case loginServiceErrors.ERROR_ACCOUNT_SUSPENDED:
          this.$accountSuspended.removeClass('hidden');
          break;
        case loginServiceErrors.ERROR_PASSWORD_TOO_SHORT:
          this.$passwordTooShort.removeClass('hidden');
          break;
        default:
          this.$genericError.removeClass('hidden');
      }
    });
  }

  enter(loginData) {
    this.$enterBtn.addClass('btn-loading');
    this.disableAll();
    loginService.login(loginData).then(this.successLogin).catch((error) => {
      this.$enterBtn.removeClass('btn-loading');
      this.enableAll();

      switch (error.code) {
        case loginServiceErrors.ERROR_ACCOUNT_SUSPENDED:
          this.$accountSuspended.removeClass('hidden');
          break;
        case loginServiceErrors.ERROR_INVALID_LOGIN:
          this.$invalidLogin.removeClass('hidden');
          break;
        default:
          this.$genericError.removeClass('hidden');
      }
    });
  }

  loginFacebook() {
    this.$loginByFacebook.addClass('btn-loading');
    this.disableAll();

    _require(['metrics'], () => trackable.eventTracker.track(Metrics.Events.ClickedFacebookLoginButton));

    const eventProps = {
      has_authenticated: false,
    };

    const scope = 'email,user_birthday';
    loginService.fbLogin(scope).then(this.facebookSuccessLogin).catch((error) => {
      this.renderRecoveryPage();
      $('.js-emergence-alert').show();

      this.$loginByFacebook.removeClass('btn-loading');
      this.enableAll();
      const resp = error.facebookResponse;

      switch (error.code) {
        case loginServiceErrors.ERROR_FACEBOOK_NOT_AUTHORIZED:
          eventProps.reason = 'has_not_authorized';
          break;
        case loginServiceErrors.ERROR_FACEBOOK_BAD_RESPONSE:
          eventProps.reason = resp.status;
          Rollbar.error('[FB_LOGIN] Bad response', { status: resp.status, url: window.location.href });
          break;
        default:
          eventProps.reason = 'generic';
      }

      _require(['metrics'], () => trackable.eventTracker.track(Metrics.Events.ReturnedFromFacebookLogin, eventProps));
    });
  }

  loginGoogle() {
    this.$loginByGoogle.addClass('btn-loading');
    this.disableAll();

    _require(['metrics'], () => trackable.eventTracker.track(Metrics.Events.ClickedGoogleLoginButton));

    loginService.googleLogin().then(this.successLogin).catch((error) => {
      const errorCode = error.error;

      if (errorCode !== 'popup_closed_by_user') {
        Rollbar.error(`[GOOGLE_LOGIN] Error ${errorCode}`, error);
      }

      this.$loginByGoogle.removeClass('btn-loading');
      this.enableAll();
    });
  }

  loginApple() {
    this.$loginByApple.addClass('btn-loading');
    this.disableAll();

    _require(['metrics'], () => trackable.eventTracker.track(Metrics.Events.ClickedAppleLoginButton));

    loginService.appleLogin().then(this.successLogin).catch((error) => {
      const errorCode = error.error;

      if (errorCode !== 'popup_closed_by_user') {
        Rollbar.error(`[APPLE_LOGIN] Error ${errorCode}`, error);
      }

      this.$loginByApple.removeClass('btn-loading');
      this.enableAll();
    });
  }

  recover(data) {
    this.$recoveryBtn.addClass('btn-loading');
    this.disableAll();

    loginService.recover(data).then(() => {
      this.$recoverySuccess.removeClass('hidden');
    }).catch((error) => {
      switch (error.code) {
        case loginServiceErrors.ERROR_ACCOUNT_SUSPENDED:
          this.$accountSuspended.removeClass('hidden');
          break;
        case loginServiceErrors.ERROR_EMAIL_NOT_FOUND:
          this.$emailNotFound.removeClass('hidden');
          break;
        default:
          this.$genericError.removeClass('hidden');
      }
    }).then(() => {
      this.enableAll();
      this.$recoveryBtn.removeClass('btn-loading');
    });
  }

  facebookSuccessLogin() {
    switch (this.$loginByFacebook.attr('data-page')) {
      case 'evaluation':
        this.successEvaluation('/college_reviews/update_user_form');
        break;
      case 'fb-login':
        this.successEvaluation('/college_reviews/update_forms');
        break;
      default:
        this.successLogin();
    }
  }

  successEvaluation(url) {
    const actualUrl = new URL(window.location.href);
    const data = {
      form_id: actualUrl.searchParams.get('s'),
    };

    return $.ajax({
      url,
      type: 'POST',
      data,
      success(result) {
        window.dataLayer.push({
          reviewLogin: true,
          event: 'login_review',
        });
        window.location.href = result.url;
      },
      error() {
        window.location.reload();
      },
    });
  }

  successLogin() {
    if (this.options && this.options.onSuccess) {
      this.options.onSuccess();
      if (this.options.closeOnSucess) {
        this.$closeBtn.click();
      }
    } else {
      document.location.reload();
    }
  }

  closeHandler() {
    if (this.options && this.options.onClose) {
      this.options.onClose();
    }
  }

  checkForFragment() {
    if ((window.location.hash.indexOf('login') !== -1) && !window.QB.isUserSignedIn) {
      this.show();
    }
  }
}

const loginModalInstances = {};

export const getLoginModalInstance = (mainSelector = defaultMainSelector) => {
  let loginModal = loginModalInstances[mainSelector];

  if (loginModal) return loginModal;

  loginModal = new LoginModal(mainSelector);
  loginModalInstances[mainSelector] = loginModal;

  return loginModal;
};

export default LoginModal;
